module.exports = __webpack_public_path__ + "img/notify.d19bc7a0.svg";